import React, {useState} from 'react'
import bookmaker from '../../assets/icons/bookmark.svg'
import bookmakerfill from '../../assets/icons/bookmark-fill.svg'
import Loading from '../Loading/Loading'
import { FaMarker } from 'react-icons/fa'
import { LuBookMarked } from 'react-icons/lu'

const SaveIcon = ({ isSaved, setIsSaved, action }) => {
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(true);

  const save = () => {
      setLoading(true);
      setShow(false);

      setTimeout(() => {
          setLoading(false);
          setShow(true);
          setIsSaved(!isSaved);
          action();
          console.log("show 1");
      }, 1000);
  };

  return (
      <button
          onClick={save}
          className="hover:bg-neutral-100 p-2 rounded-full"
      >
          {!isSaved && show && (
              <img src={bookmaker} alt="logo" className="w-7 h-7" />
          )}
          {isSaved && show && (
              <img src={bookmakerfill} alt="logo" className="w-7 h-7" />
          )}
          {loading && <Loading width={5} />}
      </button>
  );
};

export default SaveIcon;
